import { render, staticRenderFns } from "./MerchantAudit.vue?vue&type=template&id=1fe39470&scoped=true"
import script from "./MerchantAudit.vue?vue&type=script&lang=js"
export * from "./MerchantAudit.vue?vue&type=script&lang=js"
import style0 from "./MerchantAudit.vue?vue&type=style&index=0&id=1fe39470&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe39470",
  null
  
)

export default component.exports